import {createStore, applyMiddleware} from 'redux';
import {thunk} from 'redux-thunk';
import Config from '../utils/Configuration';
import rootReducer from './reducers/index';

export const middleware = [thunk];

export const createStoreWithMiddleware = applyMiddleware(...middleware)(createStore);

const store = Config.isProdEnv
    ? createStoreWithMiddleware(rootReducer)
    : createStoreWithMiddleware(
          rootReducer,
          // eslint-disable-next-line no-underscore-dangle
          window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
      );

export default store;
